import React from 'react';

import { JqueryClassFaker } from 'components/JqueryClassFaker.jsx';

class StageComponent extends React.PureComponent {
	static defaultProps = {
		asImage: false
	};

	constructor(props) {
		super(props);
		const { onClick, stage } = this.props;
		this.onClick = onClick ? onClick.bind(null, stage) : undefined;
	}

	render() {
		const { stage, imageOverride, extraClasses, asImage } = this.props;

		if(!stage) {
			return null;
		}

		const classes = new JqueryClassFaker(extraClasses);
		classes.add(`stage_for_game_${stage.game_slug}`);
		let imageToDisplay = null;
		if(imageOverride) {
			imageToDisplay = imageOverride;
		}
		else if(stage.image_url) {
			imageToDisplay = stage.image_url;
		}
		else {

		}

		let style = null;
		if(asImage) {
			classes.add('stage stage_image');
		}
		else {
			if(this.onClick) {
				classes.add('clickable');
			}
			classes.add('stage');
			style = { backgroundImage: imageToDisplay ? `url(${imageToDisplay})` : null };
		}

		return (
			<div
				className={classes.toString()}
				onClick={asImage ? undefined : this.onClick}
				title={stage.name}
				style={style}
			>
				{!imageToDisplay &&
				<div className='no_image'>No Image {stage.name ? `(${stage.name})` : ''}</div>
				}
				{imageToDisplay &&
				<React.Fragment>
					{asImage &&
					<img
						className='stage_image_tag'
						onClick={this.onClick}
						title={stage.name}
						alt={stage.name}
						src={imageToDisplay ? imageToDisplay : null}
					/>
					}
					{!asImage &&
					<span className='name'>{stage.name}</span>
					}
				</React.Fragment>
				}

			</div>
		);
	}
}

export { StageComponent };